// @flow

import { getComponentSettings } from './main';

import { type State } from '../reducers';

type GlobalState = {
  componentSettings: State,
};

export type CTASettings = $PropertyType<State, 'pdb_cta_block'>;
export const getCTASettings = (state: GlobalState): CTASettings => {
  const cta = getComponentSettings(state).pdb_cta_block;
  if (!cta) {
    throw new Error('Missing pdb_cta_block settings in componentSettings store.');
  }
  return cta;
};

type AddToComparisonText = $PropertyType<CTASettings, 'add_to_comparison_text'>;
export const getAddToComparisonText = (state: GlobalState): AddToComparisonText => (
  getCTASettings(state).add_to_comparison_text
);

type ButtonText = $PropertyType<CTASettings, 'button_text'>;
export const getButtonText = (state: GlobalState): ButtonText => (
  getCTASettings(state).button_text
);

type DeliveryTime = $PropertyType<CTASettings, 'delivery_time'>;
export const getDeliveryTime = (state: GlobalState): DeliveryTime => (
  getCTASettings(state).delivery_time
);

type DeliveryTimeApproximately = $PropertyType<CTASettings, 'delivery_time_approximately'>;
export const getDeliveryTimeApproximately = (state: GlobalState): DeliveryTimeApproximately => (
  getCTASettings(state).delivery_time_approximately
);

type DeliveryTimeDurationSingle = $PropertyType<CTASettings, 'delivery_time_duration_single'>;
export const getDeliveryTimeDurationSingle = (state: GlobalState): DeliveryTimeDurationSingle => (
  getCTASettings(state).delivery_time_duration_single
);

type DeliveryTimeDurationPlural = $PropertyType<CTASettings, 'delivery_time_duration_plural'>;
export const getDeliveryTimeDurationPlural = (state: GlobalState): DeliveryTimeDurationPlural => (
  getCTASettings(state).delivery_time_duration_plural
);

type MaxItemsInComparison = $PropertyType<CTASettings, 'max_items_in_comparison'>;
export const getMaxItemsInComparison = (state: GlobalState): MaxItemsInComparison => (
  getCTASettings(state).max_items_in_comparison
);

type RemoveFromComparisonText = $PropertyType<CTASettings, 'remove_from_comparison_text'>;
export const getRemoveFromComparisonText = (state: GlobalState): RemoveFromComparisonText => (
  getCTASettings(state).remove_from_comparison_text
);

type VbmrText = $PropertyType<CTASettings, 'vbmr_text'>;
export const getVbmrText = (state: GlobalState): VbmrText => (
  getCTASettings(state).vbmr_text || 'VBMR'
);

export type FormData = $PropertyType<CTASettings, 'form_data'>;
export const getFormData = (state: GlobalState): FormData => (
  getCTASettings(state).form_data
);

export default null;
